import api from 'src/api';

export const postClinicProfile = (data) => {
  return api(`/clinicprofile`, data, 'post')
}

export const getClinicProfileById = (clinicId) => {
  return api(`clinicprofile/${clinicId}`, null, 'get', false, null, 'json', { _t: Date.now() });
}
export const postDoctorProfile = (data) => {
  return api(`/profile`, data, 'post');
}
export const getDoctorProfileById = (doctId) => {
  return api(`profile/${doctId}`, null, 'get');
}
export const getClinics = () => {
  return api('/clinic', null, 'get')
}
export const postCustomPatientFields = (data) => {
  return api(`/clinic/custom-fields`, data, 'post');
}




